import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocTeamGroupDetailRoute } from '@jira/router-routes__eoc-group-detail-routes/src/eocTeamGroupDetailRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { resources as groupDetailResources } from '@atlassian/eoc-group-detail/resources';
import { resources as alertListResources } from '@atlassian/eoc-alert-list/resources';
import type { Route } from '@atlassian/react-resource-router';
import GroupList, { LazyGroupDetail } from './ui/spa/eoc/group-detail/index.tsx';

export const eocTeamGroupDetailRouteEntry: Route = createEntry(eocTeamGroupDetailRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: GroupList,
	layout: opsTeamLayout,

	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		...groupDetailResources(),
		getConsolidationStateResource(),
		...alertListResources(),
	],

	navigation: {
		menuId: MenuIdPeople,
	},

	forPaint: [LazyAtlassianNavigation, LazyGroupDetail, LazyTeamDashboardSidebar],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
